import { defineMessages } from 'react-intl';

export default defineMessages({
  inCartString: {
    id: 'summary.inCartLabel',
    description: 'in cart',
    defaultMessage: 'In Cart',
  },
  remainingString: {
    id: 'remaining',
    description: 'remaining',
    defaultMessage: 'Remaining',
  },
  submittedString: {
    id: 'submitted',
    description: 'submitted',
    defaultMessage: 'Submitted',
  },
});
